import { tns } from 'tiny-slider/src/tiny-slider';

class BlockImageCarousel {
	constructor(el) {
		this.el = el;

        const sliderContainer = this.el.querySelector('.block-image-carousel__image-carousel');
        const sliderNext = this.el.querySelector('.block-image-carousel__next');
        const sliderPrev = this.el.querySelector('.block-image-carousel__prev');



        const blockSlider = tns({
            container: sliderContainer,
            controls: true,
            prevButton: sliderPrev,
            nextButton: sliderNext,
            axis: 'horizontal',
            swipeAngle: false,
            speed: 400,
            rewind: true,
            mouseDrag: true,
            slideBy: 1,
            items: 1,
            edgePadding: 0,
            gutter: 20,
            responsive: {
                768: {
                    items: 2,
                    edgePadding: 0,
                    gutter: 20
                },
                1024: {
                    items: 3,
                    edgePadding: 0,
                    center: false,
                    startIndex: 0,
                    gutter: 30
                }
            }
        });
    }
}

export default BlockImageCarousel;
